// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { ToolView } from "./ToolView.js";

export let VerticalLineToolView = function (tool)
{
    ToolView.call(this, tool);
};

VerticalLineToolView.prototype = Object.create(ToolView.prototype);

VerticalLineToolView.prototype.IsSelectCheck = function (x, y)
{
    var pX = this.screenPoints[0][0];
    var TOOL_DX_HALF = ToolView.TOOL_DX / 2;

    var xLeft = pX - TOOL_DX_HALF;
    var xRight = pX + TOOL_DX_HALF;

    return x >= xLeft && x <= xRight;
};

VerticalLineToolView.prototype.Draw = function (gr, ww, param)
{
    // Ловим ошибки
    /*
    if (screenPoints[0][0] >= ProMath.infinity || screenPoints[0][1] >= ProMath.infinity || screenPoints[0][0] <= ProMath.infinityMinus || screenPoints[0][1] <= ProMath.infinityMinus)
        return;
    */

    var pen = this.dataCacheTool.Pen;
    var x = this.screenPoints[0][0];

    var CR = ww.ClientRectangle;
    var CRY = CR.Y;

    gr.DrawLine(pen, x, CRY, x, CRY + CR.Height);
    ToolView.prototype.Draw.call(this, gr, ww, param);
};

VerticalLineToolView.prototype.DrawSelectedPoint = function (gr, ww, x, y) { };

VerticalLineToolView.prototype.DrawSelectedLine = function (gr, ww, x1, y1, x2, y2)
{
    var CR = ww.ClientRectangle;
    var CRY = CR.Y;

    ToolView.prototype.DrawSelectedLine.call(this,
        gr, ww, x1, CRY, x2, CRY + CR.Height);
};